/**
 * Запущено ли приложение как установленное PWA (окно-приложение),
 * а не во вкладке браузера. Учитывает наш manifest display: 'minimal-ui'
 * (а не только standalone) и legacy iOS Safari (navigator.standalone).
 */
export function isRunningAsPwa () {
  if (typeof window === 'undefined') return false
  const inMode = (mode) => window.matchMedia(`(display-mode: ${mode})`).matches
  return (
    inMode('standalone') ||
    inMode('minimal-ui') ||
    // inMode('fullscreen') ||
    window.navigator.standalone === true
  )
}
